import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { NgModule, LOCALE_ID, Injectable, ErrorHandler, APP_INITIALIZER } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CdkTableModule } from '@angular/cdk/table';
import { registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';
registerLocaleData(localeIt);

import { NwbAllModule } from '@wizishop/ng-wizi-bulma';

import { AppComponent } from './app.component';
import { appRoutes } from './app.routes';
import { DashboardComponent } from './dashboard/dashboard.component';
import { TipoSocioPipe, AssicuratoPipe, InizioValiditaPipe, FineValiditaPipe } from './app.pipe';
import { HeaderComponent } from './header/header.component';
import { BaseComponent } from './dashboard/base.component';
import { RinnoviComponent } from './dashboard/rinnovi.component';
import { PagamentiComponent } from './dashboard/pagamenti.component';
import { RigaPagamentiComponent } from './dashboard/riga-pagamenti.component';
import { MygroupComponent } from './dashboard/my-group/mygroup.component';
import { AddSocioGroupComponent } from './dashboard/my-group/add-socio-group.component';
import { TypeSocioComponent } from './shared/type-socio.component';
import { BaseGroupComponent } from './dashboard/my-group/base-group.component';
import { AddAmicoFedeleComponent } from './dashboard/my-group/add-amico-fedele.component';
import { ModifySocioComponent } from './dashboard/my-group/modify-socio.component';
import { AssocNazioniResolver } from './shared/assocnazioni.resolver';
import { ModifySocioResolver } from './dashboard/my-group/modify-socio.resolver';
import { ModifyAmicoFedeleComponent } from './dashboard/my-group/modify-amico-fedele.component';
import { PagamentoRinnovoComponent } from './nuovo-pagamento/pagamento-rinnovo.component';
import { ModifyAmicoFedeleResolver } from './dashboard/my-group/modify-amico-fedele.resolver';
import { KeyFilterModule } from 'primeng/keyfilter';
import { SpinnerModule } from 'primeng/spinner';

import { CalendarModule } from 'primeng/calendar';
import { PublicUserRegisterComponent } from './public/public-user-register.component';
import { PasswordValidatorDirective } from './shared/password.validator';
import { ChangePasswordComponent } from './dashboard/change-password.component';

import { FileSaverModule } from 'ngx-filesaver';

import * as Sentry from "@sentry/browser";
import { environment } from 'src/environments/environment';
import { AuthModule, OidcConfigService } from 'angular-auth-oidc-client';
import { configureAuth } from './auth/auth.config';
import { AuthDolomitiInterceptor } from './auth/auth.interceptor';
import { NgxStripeModule } from 'ngx-stripe';

if(environment.production) {
  Sentry.init({
    dsn: "https://48f193973f64013eec91fb38e0584b08@sentry.scponline.it/26",
    enabled: environment.production,
    debug: true
  });
}


@Injectable()
export class SentryErrorHandler implements ErrorHandler {
  constructor() { }
  handleError(error) {
    Sentry.captureException(error.originalError || error);
    throw error;
  }
}


@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    TipoSocioPipe,
    InizioValiditaPipe,
    FineValiditaPipe,
    AssicuratoPipe,
    HeaderComponent,
    BaseComponent,
    RinnoviComponent,
    PagamentiComponent,
    RigaPagamentiComponent,
    MygroupComponent,
    AddSocioGroupComponent,
    AddAmicoFedeleComponent,
    TypeSocioComponent,
    BaseGroupComponent,
    ModifySocioComponent,
    ModifyAmicoFedeleComponent,
    PagamentoRinnovoComponent,
    PublicUserRegisterComponent,
    PasswordValidatorDirective,
    ChangePasswordComponent
  ],
  entryComponents: [
    ChangePasswordComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    AuthModule.forRoot(),
    NgxStripeModule.forRoot(environment.publicStripeKey),
    NwbAllModule,
    CdkTableModule,
    FileSaverModule,
    KeyFilterModule,
    SpinnerModule,
    CalendarModule,
    RouterModule.forRoot(appRoutes, { relativeLinkResolution: 'legacy', enableTracing: environment.showRouteEvent })
  ],
  providers: [
    OidcConfigService,
    { provide: LOCALE_ID, useValue: environment.locale },
    {
      provide: APP_INITIALIZER,
      useFactory: configureAuth,
      deps: [OidcConfigService],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthDolomitiInterceptor,
      multi: true
    },
    //{ provide: ErrorHandler, useClass: SentryErrorHandler },
    
    AssocNazioniResolver,
    ModifySocioResolver,
    ModifyAmicoFedeleResolver
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
